<template>
    <section class="Section">
        <div class="Container">
            <div class="Box">
                <div class="Bookmark Iconed UserIcon"><span>{{ this.risorse["Profilo"] }}</span> <i>{{ this.risorse["Benvenuto"] }} {{ this.$store.getters.getNome}} {{ this.$store.getters.getCognome}}</i></div>
            </div>
        </div>
        <div class="Container">
            <div class="Box">
                <div class="SidebarHolder Profilepages">
                    <div class="SidebarSx">
                        <div class="Frame">
                            <nav class="ProfileMenu">
                                <ul>
                                    <li><router-link :to="{'name': 'UserDetails'}"  active-class="SelectedItemLink" exact>{{ this.risorse["DatiUtente"] }}</router-link></li>
                                    <li><router-link :to="{'name' : 'PaymentDeadlines'}" active-class="SelectedItemLink" exact>{{ this.risorse["Scadenzario"] }}</router-link></li>
                                    <li><router-link :to="{'name': 'DestinationAddresses'}"  active-class="SelectedItemLink" exact>{{ this.risorse["IndirizziDestinazione"] }}</router-link></li>
                                    <li><router-link :to="{'name': 'BillingAddresses'}"  active-class="SelectedItemLink" exact>{{ this.risorse["IndirizziFatturazione"] }}</router-link></li>
                                    <li><router-link :to="{'name': 'OrderHistory'}"  active-class="SelectedItemLink" exact>{{ this.risorse["StoricoOrdini"] }}</router-link></li>
                                    <li><router-link :to="{'name': 'ChangePassword'}"  active-class="SelectedItemLink" exact>{{ this.risorse["CambiaPassword"] }}</router-link></li>
                                    <li><router-link :to="{'name': 'ChangePersonalData'}"  active-class="SelectedItemLink" exact>{{ this.risorse["ModdatiPers"] }}</router-link></li>
                                    <li><a href="javascript:void(0)" @click="this.logout()">{{ this.risorse["Logout"] }}</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="SidebarDx">
                        <div class="Frame">
                            <!-- Inizio dati utente -->
                            <router-view />
                            <!-- Fine dati utente -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ModalLogout v-model="this.showModal" :message="this.modalMessage" ></ModalLogout>
</template>


<script>

import ModalLogout from "@/components/modals/ModalLogout.vue";
import {risorseMixin} from "@/mixin.js";

export default {
    name: "ProfileDetail",
    data(){
        return {
            showModal: false,
            modalMessage: ""
        }
    },
    mixins:[risorseMixin],
    methods: {
        logout: function(){
            this.modalMessage = this.risorse["SicuroLogout"];
            this.showModal = true;
            
        }
    },
    components: {
        ModalLogout
    }
}
</script>
<style>

    .ProfileMenu>ul>li> a.SelectedItemLink{
        background-image: none;
        font-weight: 700;
    }

</style>